import Space from "antd/es/space";
import Text from "common/Typography/Text";
import styled from "styled-components";
import { openMessage } from "utils/misc.tsx";
import { getSellExistingCoinWarning } from "@shared/features/trades/common/utils.ts";
import Radio from "common/Radio/Radio";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface SellExistingCoinsOptionsProps {
  sellCoins: boolean;
  setSellCoins: (sellCoins: boolean) => void;
  isSymbolInactive?: boolean;
  isBot?: boolean;
}

const SellExistingCoinsOptions = ({
  sellCoins,
  setSellCoins,
  isSymbolInactive,
  isBot,
}: SellExistingCoinsOptionsProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  const onSellClick = () => {
    if (isSymbolInactive) {
      openMessage(getSellExistingCoinWarning(isBot), "warning");
    }
  };

  return (
    <Radio.Group
      onChange={(e) => {
        if (!isSymbolInactive) setSellCoins(e.target.value);
      }}
      value={sellCoins}
      style={{ marginTop: 8 }}
    >
      <Space orientation="vertical">
        <StyledRadio
          value={true}
          onClick={onSellClick}
          $disabled={isSymbolInactive}
        >
          <Text>{t("cancel_trade.sell_coins_at_current_price")}</Text>
        </StyledRadio>
        <Radio value={false}>
          <Text>{t("cancel_trade.keep_coins")}</Text>
        </Radio>
      </Space>
    </Radio.Group>
  );
};

export default SellExistingCoinsOptions;

const StyledRadio = styled(Radio)<{ $disabled?: boolean }>`
  ${(p) =>
    p.$disabled &&
    `
    opacity: 0.3
  `};
`;
